<div class="field-dialog__content__scroll field-dialog__table">
  <mat-table matSort [dataSource]="occurrences" fusePerfectScrollbar>
    <ng-container matColumnDef="scheduledDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">
        {{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.DATE' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let occurrence">
        <span class="mobile-label" fxHide fxShow.xs>{{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.DATE' | translate }}:</span>
        {{ occurrence.scheduledDate | date: 'dd/MM/yyyy' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="number">
      <mat-header-cell *matHeaderCellDef>
        {{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.NUMBER' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let occurrence">
        <span class="mobile-label" fxHide fxShow.xs
          >{{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.NUMBER' | translate }}:</span
        >
        {{ (occurrence.maintenance && occurrence.maintenance.number && occurrence.maintenance.number) || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="company">
      <mat-header-cell *matHeaderCellDef>
        {{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.COMPANY' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let occurrence">
        <span class="mobile-label" fxHide fxShow.xs
          >{{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.COMPANY' | translate }}:</span
        >
        {{ (occurrence.maintenance && occurrence.maintenance.company && occurrence.maintenance.company.name) || '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>
        {{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.STATUS' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let occurrence">
        <span class="mobile-label" fxHide fxShow.xs
          >{{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.STATUS' | translate }}:</span
        >
        <span
          [ngClass]="occurrence.maintenance.status + '-status-maintenance-fg'"
          *ngIf="occurrence.maintenance && occurrence.maintenance.status"
          >{{ occurrence.maintenance.status | statusMaintenance }}
        </span>
        <span *ngIf="!occurrence.maintenance || !occurrence.maintenance.status">Aguardando...</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="noData">
      <mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        {{ 'RECURRENCES.DIALOG.TABS.OCCURRENCES.NO_DATA' | translate }}
      </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row *matFooterRowDef="['noData']" [hidden]="isLoading || occurrences?.length"></mat-footer-row>
  </mat-table>
  <mat-paginator [length]="resultsLength" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
</div>
